import { Col, Row, Space, Typography } from "antd";
import React from "react";
import CustomBtn from "../../../../shared/CustomBtn/CustomBtn";
import { FormikProps } from "formik";
import TimeLockStaking from "../../../../TimelockStaking/TimelockStaking";

import * as style from "../StepsStyle.module.scss"

type Props = {
  formik: FormikProps<any>;
  isUk?: boolean;
  onClickContinue: () => void;
  onClickCancel: () => void;
};

export const TimelockStep = ({
  formik,
  isUk,
  onClickContinue,
  onClickCancel,
}: Props) => {
  return (
    <div style={{ marginTop: "50px" }}>
      <Row>
        <Col className={style.mainLabel}>
          <Typography.Title level={5}>Timelock</Typography.Title>
        </Col>
      </Row>

      <TimeLockStaking isUk={isUk} formik={formik} />

      <Space direction="horizontal" className={style.footer}>
        <CustomBtn
          myType="cancel"
          onClick={onClickCancel}
          className={style.button}
        >
          Cancel
        </CustomBtn>

        <CustomBtn
          myType="submit"
          onClick={onClickContinue}
          disabled={formik.values.timelockDuration === null}
          className={style.button}
        >
          Continue
        </CustomBtn>
      </Space>
    </div>
  );
};
